var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames, ginni } from '@shapeable/utils';
import { useComponentProps } from '../context/component-props-context';
import { Icon } from '../elements/icon';
import HighlightText from '../elements/highlight-text';
var cls = classNames('option-menu-item');
export var OptionMenuItemDefaultProps = {
  iconSize: 16,
  verticalPadding: 8,
  horizontalPadding: 12,
  colors: {
    outline: 'transparent',
    border: 'just-visible',
    text: 'strong',
    background: 'canvas',
    fill: 'fill',
    disabled: {
      hover: {
        background: 'canvas'
      }
    },
    hover: {
      background: 'subtle-chrome'
    },
    selected: {
      background: 'highlight'
    },
    active: {
      outline: 'focus-highlight',
      background: 'subtle-chrome'
    }
  },
  labelProps: {}
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    ", ";\n    outline-width: 1px;\n    outline-offset: -1px; \n    outline-style: solid;\n    border-top-width: 1px;\n    border-top-style: solid;\n    font-size: 1em;\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    \n    ", "\n\n    ", "\n\n    &:first-child {\n      border-top: none;\n    }\n\n\n  "], ["\n    ", ";\n    outline-width: 1px;\n    outline-offset: -1px; \n    outline-style: solid;\n    border-top-width: 1px;\n    border-top-style: solid;\n    font-size: 1em;\n    display: flex;\n    align-items: center;\n    padding: 0.5rem 1rem;\n    cursor: pointer;\n    \n    ", "\n\n    ", "\n\n    &:first-child {\n      border-top: none;\n    }\n\n\n  "])), theme.APPLY_COLORS, function (_a) {
    var isDisabled = _a.isDisabled;
    return isDisabled && css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      cursor: default;\n      pointer-events: none;\n      opacity: 0.3;\n    "], ["\n      cursor: default;\n      pointer-events: none;\n      opacity: 0.3;\n    "])));
  }, function (_a) {
    var isActive = _a.isActive;
    return isActive && css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n      box-shadow: 0 0 3px 1px ", ";\n    "], ["\n      box-shadow: 0 0 3px 1px ", ";\n    "])), theme.COLOR('focus-shadow'));
  })
});
var IconStyles = breakpoints({
  base: css(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    flex-shrink: 0;\n  "], ["\n    flex-shrink: 0;\n  "])))
});
var IconBufferStyles = breakpoints({
  base: css(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    ", "\n    display: block;\n    font-size: 0;\n    flex-shrink: 0;\n  "], ["\n    ", "\n    display: block;\n    font-size: 0;\n    flex-shrink: 0;\n  "])), function (_a) {
    var size = _a.size;
    return css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      width: ", "px;\n      height: ", "px;\n    "], ["\n      width: ", "px;\n      height: ", "px;\n    "])), size, size);
  })
});
var LabelStyles = breakpoints({
  base: css(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n    white-space: nowrap;\n  "], ["\n    white-space: nowrap;\n  "])))
});
var OptionStyles = breakpoints({
  base: css(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    \n  "], ["\n    display: flex;\n    align-items: center;\n    gap: ", ";\n    \n  "])), theme.UNIT(2))
});
// -------- Components -------->
var My = {
  NAME: 'OptionMenuItem',
  Container: styled.li(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Option: styled.span(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), OptionStyles),
  Icon: styled(Icon)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), IconStyles),
  IconBuffer: styled.span(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), IconBufferStyles),
  Label: styled.span(templateObject_13 || (templateObject_13 = __makeTemplateObject(["", ""], ["", ""])), LabelStyles)
};
export var OptionMenuItem = React.forwardRef(function (props, ref) {
  var componentProps = useComponentProps(My.NAME, OptionMenuItemDefaultProps, props);
  var className = componentProps.className,
    children = componentProps.children,
    iconSize = componentProps.iconSize,
    isDisabled = componentProps.isDisabled,
    item = componentProps.item,
    index = componentProps.index,
    colors = componentProps.colors,
    isActive = componentProps.isActive,
    isSelected = componentProps.isSelected,
    component = componentProps.component,
    _a = componentProps.highlightText,
    highlightText = _a === void 0 ? '' : _a,
    highlightTextClassName = componentProps.highlightTextClassName,
    onMouseOver = componentProps.onMouseOver,
    onClick = componentProps.onClick,
    labelProps = componentProps.labelProps;
  var id = item.id,
    label = item.label,
    data = item.data;
  var Component = component || item.component;
  var Icon = item.iconComponent;
  var handleMouseOver = function (event) {
    if (onMouseOver) {
      onMouseOver({
        item: item,
        index: index,
        event: event
      });
    }
  };
  if (isSelected) {
    ginni.verbose.log('OptionMenuItem', 'isSelected', {
      id: id,
      label: label,
      data: data
    });
  }
  return React.createElement(My.Container, {
    ref: ref,
    isDisabled: isDisabled,
    onClick: onClick,
    // this stops blur events on hooked inputs firing before the click 
    onMouseDown: function (e) {
      return e.preventDefault();
    },
    onMouseOver: handleMouseOver,
    isActive: isActive,
    isSelected: isSelected,
    colors: colors,
    className: cls.name(className)
  }, Component ? React.createElement(Component, {
    isSelected: isSelected,
    item: item,
    highlightText: highlightText
  }, children) : React.createElement(My.Option, null, Icon ?
  // adding icon size here ensures that icons are the same width
  React.createElement(My.Icon, {
    size: iconSize
  }, React.createElement(Icon, {
    size: iconSize
  })) : React.createElement(My.IconBuffer, {
    size: iconSize
  }), React.createElement(My.Label, __assign({}, labelProps), React.createElement(HighlightText, {
    highlightClassName: highlightTextClassName,
    searchWords: [highlightText],
    textToHighlight: label || ''
  }))));
});
/* @ts-ignore */
OptionMenuItem.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12, templateObject_13;